var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCluster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333008 21.5V0.5H11.9997V5.16667H23.6663V21.5H0.333008ZM2.66634 19.1667H4.99967V16.8333H2.66634V19.1667ZM2.66634 14.5H4.99967V12.1667H2.66634V14.5ZM2.66634 9.83333H4.99967V7.5H2.66634V9.83333ZM2.66634 5.16667H4.99967V2.83333H2.66634V5.16667ZM7.33301 19.1667H9.66634V16.8333H7.33301V19.1667ZM7.33301 14.5H9.66634V12.1667H7.33301V14.5ZM7.33301 9.83333H9.66634V7.5H7.33301V9.83333ZM7.33301 5.16667H9.66634V2.83333H7.33301V5.16667ZM11.9997 19.1667H21.333V7.5H11.9997V9.83333H14.333V12.1667H11.9997V14.5H14.333V16.8333H11.9997V19.1667ZM16.6663 12.1667V9.83333H18.9997V12.1667H16.6663ZM16.6663 16.8333V14.5H18.9997V16.8333H16.6663Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCluster);
export default __webpack_public_path__ + "static/media/icon_cluster.3e9eb57c149e6cbec77f10d6d0418ce7.svg";
export { ForwardRef as ReactComponent };